import { render } from "./privacy-policy.vue?vue&type=template&id=e759eb38&ts=true"
import script from "./privacy-policy.vue?vue&type=script&lang=ts"
export * from "./privacy-policy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__